import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { TenantRegistrationForm } from "./TenantRegistrationForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface ITenantRegistrationCreateProps {}

export const TenantRegistrationCreate = (
  props: ITenantRegistrationCreateProps
) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.master-tenant-registrations.title.create">
      <TenantRegistrationForm />
    </Create>
  );
};
